export interface DashboardTilePosition {
  x: number;
  y: number;
  cols: number;
  rows: number;
}

export interface TableColumn {
  key: string;
  header: string;
  type: 'text' | 'date' | 'boolean' | 'button' | 'select';
  sortable?: boolean;
  visible?: boolean;
}

export interface TableVisualizationSettings {
  columns: TableColumn[];
  sort?: {
    column: string;
    direction: 'asc' | 'desc';
  };
  pageable?: boolean;
  pageSize?: number;
  pageSizeOptions?: number[];
  filterable?: boolean;
  rowClickable?: boolean;
  onRowClick?: (row: any) => void;
  rowHover?: boolean;
  striped?: boolean;
  dense?: boolean;
  searchable?: boolean;
}

export interface GraphVisualizationSettings {
  type: 'pie' | 'bar' | 'line';
  xAxis?: string;
  yAxis?: string;
  groupBy?: string;
  valueField?: string;
  labelField?: string;
}

export interface TileVisualizationSettings {
  display: 'count' | 'percentage' | 'custom';
  valueField: string;
  label?: string;
  format?: string;
}

export interface DashboardTileSettings {
  table?: TableVisualizationSettings;
  graph?: GraphVisualizationSettings;
  tile?: TileVisualizationSettings;
}

export interface DashboardTile {
  id: string;
  name: string;
  description: string;
  type: 'table' | 'graph' | 'tile';
  dataSource: string;
  position: DashboardTilePosition;
  settings: DashboardTileSettings;
  requiredRoles?: string[];
}

export class DashboardTileModel implements DashboardTile {
  id: string;
  name: string;
  description: string;
  type: 'table' | 'graph' | 'tile';
  dataSource: string;
  position: DashboardTilePosition;
  settings: DashboardTileSettings;
  requiredRoles?: string[];

  constructor(data: DashboardTile) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.type = data.type;
    this.dataSource = data.dataSource;
    this.position = { ...data.position };
    this.settings = { ...data.settings };
    this.requiredRoles = data.requiredRoles;
  }

  updatePosition(position: Partial<DashboardTilePosition>) {
    this.position = { ...this.position, ...position };
  }

  updateSettings(settings: Partial<DashboardTileSettings>) {
    this.settings = { ...this.settings, ...settings };
  }

  toJSON(): DashboardTile {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      dataSource: this.dataSource,
      position: { ...this.position },
      settings: { ...this.settings },
      requiredRoles: this.requiredRoles
    };
  }
} 